module.exports = __webpack_public_path__ + "static/media/1002245.6b53db88.png";